export default __webpack_public_path__ + "static/media/6-Bestflix.faaff912.png";